import React,{useState,useEffect} from "react";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Button } from "bootstrap/dist/js/bootstrap.min";
import { useNavigate } from "react-router-dom";
const ViewBatches = () => {
  const [batches, setBatches] = useState([]);
  const { user } = useAuth();
    const navigate=useNavigate();   
  const fetchBatches = async () => {
    try {
      const response = await axios.get(`${Base_URL}/BatchMaster/GetAllBatches/${user?.organisationId}`);
      setBatches(response.data);
     
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };
  const handleEdit=()=>{
    console.log("Batches");
  }
  useEffect(() => {
    fetchBatches();
  }, []);
 console.log(batches);
  // Inline styles
  const containerStyle = {
   
    margin: "50px auto",
    padding: "20px",
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "Poppins, sans-serif",
    fontSize: "15px",
  };

  const headStyle = {
    background: "#0077ff",
    color: "#fff",
  };

  const cellStyle = {
    padding: "14px",
    textAlign: "left",
    borderBottom: "1px solid #e3e3e3",
  };

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        <thead style={headStyle}>
          <tr>
            <th style={cellStyle}>Batch Id</th>
            <th style={cellStyle}>Product Name</th>
            <th style={cellStyle}>Manufacturing Date</th>
            <th style={cellStyle}>Expiry Date</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {batches.map((batch, index) => {
            const rowStyle = {
              background: index % 2 === 0 ? "#fafafa" : "#fff",
              cursor: "pointer",
            };

            const hoverRowStyle = {
              ...rowStyle,
              background: "rgba(0,119,255,0.06)",
              transition: "0.3s",
            };

            return (
              <tr
                key={batch.batches.batchId}
                style={rowStyle}
                onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverRowStyle)}
                onMouseLeave={(e) => Object.assign(e.currentTarget.style, rowStyle)}
              >
                <td style={cellStyle}>{batch.batches.batchId}</td>
                <td style={cellStyle}>{batch.items.itemName}</td>
                <td style={cellStyle}>
                  {new Date(batch.batches.mfgDate).toLocaleDateString()}
                </td>
                <td style={cellStyle}>
                  {new Date(batch.batches.expiryDate).toLocaleDateString()}
                </td>
                <td><button onClick={()=>navigate(`/editBatch/${batch.batches.batchId}`)}>Edit</button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ViewBatches;
